import React, { useEffect, useState } from "react";
import searchIcon from "../../img/icon-search.png";
import "../../css/common.css";
import dotsIcon from "../../img/icondots.png";
import { Link, useHistory } from "react-router-dom";
import { useFetchData } from "../../hooks/useFetchData";
import { BACKEND_URL, GeneralStatus } from "../../utils/constant";
import { Pagination } from "../../components/Pagination";
import editIcon from "../../img/icon-edit.png";
import trashCanIcon from "../../img/icon-trash.png";
import detailIcon from "../../img/icon-details.png";
import crossIcon from "../../img/icon-cross.png";
import reloadIcon from "../../img/icon-reload.png";
import { useFormatMessage } from "../../hooks/useFormatMessage";
import { useAuth } from "../../context/AuthProvider";
import DeleteConfirmPopup from "../../components/DeleteConfirmPopup";
import { ResetPasswordPopup } from "../../components/ResetPasswordPopup";
import moment from "moment";

export default function PaymentReceive() {
    const history = useHistory();
    const { setPopup } = useAuth();
    const currentPath = history.location.pathname;
    const [isOptionOpen, setisOptionOpen] = useState(false);
    const { data, setCurrentPage, setQuery, reload } = useFetchData({
        url: BACKEND_URL + "/paymentReceive",
        defaultQuery: "",
    });
    const formatMessage = useFormatMessage();

    const toggleOptions = (id) => {
        const optionEl = document.getElementById(id);
        const activeOptionEl = document.querySelectorAll(".popup-options.open");
        console.log(activeOptionEl);
        if (activeOptionEl.length === 0 || activeOptionEl[0] == optionEl) {
            optionEl.classList.toggle("open");
            setisOptionOpen(optionEl.classList.contains("open"));
        }
    };

    const onSearchChange = (e) => {
        const text = e.target.value;
        setQuery({
            invoice_number: text.trim(),
        });
    };

    const onDeleteClick = (e) => {
        e.preventDefault();
        const id = e.target.parentNode.id
            ? e.target.parentNode.id
            : e.target.parentNode.parentNode.id;
        setPopup(
            <DeleteConfirmPopup
                id={id}
                reload={reload}
                entity="paymentReceive"
            />
        );
    };

    useEffect(() => {
        const openedEl = document.querySelector(".popup-options.open");

        const handleDocumentClick = (e) => {
            if (e.target != openedEl && !openedEl.contains(e.target)) {
            }
            openedEl.classList.remove("open");
            setisOptionOpen(false);
        };
        if (openedEl) {
            setTimeout(() => {
                document.addEventListener("click", handleDocumentClick);
            }, 100);
        }
        return () => {
            document.removeEventListener("click", handleDocumentClick);
        };
    }, [isOptionOpen]);

    return (
        <div className="page-layout">
            <div className="page-header">
                <h1>{formatMessage("common.paymentReceiveList")}</h1>
                <div className="search-bar">
                    <img src={searchIcon} />
                    <input
                        className="x-input"
                        type="search"
                        onChange={onSearchChange}
                    />
                </div>
            </div>

            <div className="table-container">
                <table className="x-table header-gray">
                    <thead>
                        <tr>
                            <th>{formatMessage("common.invoiceNumber")}</th>
                            <th>{formatMessage("common.receiveAmount")}</th>
                            <th>{formatMessage("common.totalAmount")}</th>
                            <th>{formatMessage("common.transactionDate")}</th>
                            <th className="button-col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.results.map((item, i) => {
                            const index = (data.page - 1) * data.limit + i + 1;
                            return (
                                <tr key={i}>
                                    <td>{item.invoice.invoice_number}</td>
                                    <td>{item.receive_amount}</td>
                                    <td>{item.invoice.total_amount}</td>
                                    <td>
                                        {moment(item.transaction_date).format(
                                            "DD/MM/YYYY"
                                        )}
                                    </td>
                                    <td className="button-col">
                                        <div className="flex items-center">
                                            <span
                                                className={
                                                    "flex mr-7 items-center justify-center flex-shrink-0 w-24 h-7 rounded-2xl bg-gray-100"
                                                }
                                            >
                                                {item.status}
                                            </span>
                                            <img
                                                src={detailIcon}
                                                className="col-button"
                                                onClick={() =>
                                                    setPopup(
                                                        <DetailPopup
                                                            data={item}
                                                        />
                                                    )
                                                }
                                            />
                                            <img
                                                className="col-button"
                                                src={dotsIcon}
                                                onClick={() =>
                                                    toggleOptions(
                                                        item.payment_receive_id
                                                    )
                                                }
                                            />
                                        </div>
                                        <div
                                            className="popup-options"
                                            id={item.payment_receive_id}
                                        >
                                            <a href="" onClick={onDeleteClick}>
                                                <img src={trashCanIcon} />
                                                {formatMessage("common.remove")}
                                            </a>
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>

            <div className="pagination-container">
                <Pagination data={data} setCurrentPage={setCurrentPage} />
            </div>
        </div>
    );
}

const DetailPopup = ({ data }) => {
    const formatMessage = useFormatMessage();
    const { setPopup } = useAuth();

    return (
        <div className="popup relative">
            <h4 className="mb-10">
                {formatMessage("common.paymentReceive")}
                {formatMessage("common.information")}
            </h4>
            <div className="mb-8">
                <span className="inline-block w-60">
                    {formatMessage("common.invoiceNumber")}
                </span>
                <span className="mr-20">:</span>
                <span className="inline-block w-52">
                    {data.invoice.invoice_number}
                </span>
            </div>
            <div className="mb-8">
                <span className="inline-block w-60">
                    {formatMessage("common.receiveAmount")}
                </span>
                <span className="mr-20">:</span>
                <span className="inline-block w-52">{data.receive_amount}</span>
            </div>
            <div className="mb-8">
                <span className="inline-block w-60">
                    {formatMessage("common.remainingAmount")}
                </span>
                <span className="mr-20">:</span>
                <span className="inline-block w-52">
                    {data.remainingAmount}
                </span>
            </div>
            <div className="mb-8">
                <span className="inline-block w-60">
                    {formatMessage("common.totalAmount")}
                </span>
                <span className="mr-20">:</span>
                <span className="inline-block w-52">
                    {data.invoice.total_amount}
                </span>
            </div>
            <div className="mb-8">
                <span className="inline-block w-60">
                    {formatMessage("common.transactionDate")}
                </span>
                <span className="mr-20">:</span>
                <span className="inline-block w-52">
                    {data.transaction_date
                        ? moment(data.transaction_date).format("DD/MM/YYYY")
                        : ""}
                </span>
            </div>

            <img
                className="absolute top-7 right-8 cursor-pointer w-3 h-auto"
                src={crossIcon}
                onClick={() => setPopup(null)}
            />
        </div>
    );
};
